<template>
    <!-- v-on="$listeners" -->
  <treeselect
    v-bind="$attrs"
    :async="isOptionsLimitExceeded"
    retry-text=""
    :search-prompt-text="searchPromptText"
    :auto-load-root-options="false"
    :options="options"
    :load-options="loadOptions"
    :disable-fuzzy-matching="true"
    @select="$emit('select', $event)"
    @deselect="$emit('deselect', $event)"
    @change="$emit('change', $event)"
    @input="$emit('input', $event)"
    @update:modelValue="$emit('update:modelValue', $event)"

  >
    <slot v-for="(_, name) in $slots" :name="name" :slot="name"></slot>
    <template v-for="(_, name) in $scopedSlots" :slot="name" slot-scope="slotData">
      <slot :name="name" v-bind="slotData"></slot>
    </template>
  </treeselect>
</template>

<script>
export default {
  name: "CustomTreeSelect",

  props: {
    options: { default: null },
    optionsLimit: { default: 500 }
  },

  computed: {
    isOptionsLimitExceeded() {
      return this.options?.length > this.optionsLimit;
    },

    searchPromptText() {
      return this.$t('Webportal.ItemCountExceedsThreshold', { count: this.options?.length, threshold: this.optionsLimit });
    }
  },

  methods: {
    loadOptions({ action, searchQuery, callback }) {
      if (action === 'ASYNC_SEARCH') {
        searchQuery = searchQuery.toLowerCase();
        const options = this.options.filter(item => item.label.toLowerCase().includes(searchQuery));

        if (options.length <= this.optionsLimit)
          callback(null, options);
        else
          callback(this.$t('Webportal.ItemCountExceedsThreshold', { count: options.length, threshold: this.optionsLimit }));
      }
    },
  }
}
</script>
